import { Config, getAccount } from '@wagmi/core'
import { rainbowKitConfig } from 'utils/rainbow-config'

export function getRealChainId() {
  const chainId = getAccount(rainbowKitConfig as Config).chainId

  return chainId
}
